<template>
  <div>
    <h2>About History Reconsidered</h2>
    <div class="container">
      <img
        src="@/assets/images/lee-and-kathleen.jpg"
        alt="Lee Offen & Kathleen McLaughlin"
      />

      <p>
        HistoryReconsidered.net was conceived and written by Lee Offen.
        <br />
        <br />Lee is a retired U.S. Army Major who resides in Springfield
        Virginia. He is an Armored Cavalry Combat Veteran, former Airborne
        Infantryman and a recipient of the Bronze Star. He has his Masters
        Degree in Government from Campbell University and was Assistant
        Professor of Military Science at Georgetown University and George Mason
        University. A graduate of the U.S. Army Military History Instructors
        Course, he is also a historical re-enactor and avid student of 17th and
        18th century history.
      </p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
img {
  display: inline-block;
  width: 35rem;
  float: left;
  margin-right: 2rem;
}
</style>
